export const _checklistStatus = state => state.checklist.status
export const _checklistError = state => state.checklist.error
export const _checklistStep = state => state.checklist.step
